// extracted by mini-css-extract-plugin
module.exports = {"maxWidth500":"empty-message_maxWidth500__1A-XP","maxWidth350":"empty-message_maxWidth350__1Da1_"};